export default __webpack_public_path__ + "static/media/background-elements.ef4d2147.png";